/**
 * A25, the Sections register (F5): one List, the People register's pattern.
 * One read of every section answers the rows, the head's count and figures (A19 to A24)
 * and how many the current filter hides, so a count is never from another
 * read (R5). Find, program, term and active or archive are the List's own
 * tools: they never commit (R6). A row visits the section's record, on the
 * Registrar fallback until A6 registers it.
 */

import { Bento } from "@/components/ui/box";
import type { Box, ListBox } from "@/components/ui/box.schema";
import type { Course } from "@/lib/api/courses";

/** The register's page: its one List. */
export function SectionsRegister({ list, after = [] }: { list: ListBox<Course[], Course>; after?: Box[] }) {
  return <Bento id="sections" journey="registrar-sections" boxes={[list, ...after]} />;
}
